// extracted by mini-css-extract-plugin
module.exports = {"Tabs__heading":"Tabs_Tabs__heading__WJcNU","Tabs__title":"Tabs_Tabs__title__cjly1","Tabs__navigation":"Tabs_Tabs__navigation__WhyMb","active":"Tabs_active__Qr3fw"};